import { useCallback, useMemo } from "books/act";
import { BlogPost } from "names/blog";
import { STATIC_ROUTES } from "nodes/codex/CodexRoutes";
import { POST_INDEX } from "names/blog";

type ReturnType = {
  blogPosts: BlogPost[];
  postAt: (index: POST_INDEX) => BlogPost;
};

const VOID_POST: BlogPost = {
  imgSrc: "",
  imgSize: 0,
  name: "",
  route: "/" as STATIC_ROUTES,
  date: "",
};

const useBlogPosts = (): ReturnType => {
  const blogPosts = useMemo(() => {
    const posts: Array<BlogPost> = [];
    posts[POST_INDEX.BLOG_INTRODUCE_CARD_MEMOIR] = {
      imgSrc: process.env.PUBLIC_URL + "/blog/~72da_Banner.png",
      imgSize: 621,
      name: "Introducing Card Memoir: Reimagine Information Management",
      route: STATIC_ROUTES.BLOG_INTRODUCE_CARD_MEMOIR,
      date: "March 2025",
    };
    posts[POST_INDEX.BLOG_COMMUNITIES_TEMPLATE_DECK] = {
      imgSrc: process.env.PUBLIC_URL + "/blog/~0558_Banner.png",
      imgSize: 1184,
      name: "52 Cards Deck Template for Communities",
      route: STATIC_ROUTES.BLOG_COMMUNITIES_TEMPLATE_DECK,
      date: "April 2025",
    };
    posts[POST_INDEX.BLOG_DRAWING_CHALLENGE_CARD] = {
      imgSrc: process.env.PUBLIC_URL + "/blog/~855d_Banner.png",
      imgSize: 1168,
      name: "7 days Drawing Challenge for Communities",
      route: STATIC_ROUTES.BLOG_DRAWING_CHALLENGE_CARD,
      date: "April 2025",
    };
    posts[POST_INDEX.BLOG_ORDER_PHYSICAL_PRINTS] = {
      imgSrc: process.env.PUBLIC_URL + "/blog/~e04a_Banner.png",
      imgSize: 409,
      name: "Order Physical Prints",
      route: STATIC_ROUTES.BLOG_ORDER_PHYSICAL_PRINTS,
      date: "May 2025",
    };
    return posts;
  }, []);

  const handleGetPostAt = useCallback(
    (index: POST_INDEX) => blogPosts[index] ?? VOID_POST,
    [blogPosts]
  );

  return {
    blogPosts,
    postAt: handleGetPostAt,
  };
};

export default useBlogPosts;
